'use strict';

import './component.scss';